module.exports = __webpack_public_path__ + "static/media/заказ-цветов.10ff40bd.jpg";